import { render, staticRenderFns } from "./RuleCustomEditOrder.vue?vue&type=template&id=f5e0a7d8&scoped=true"
import script from "./RuleCustomEditOrder.vue?vue&type=script&lang=js"
export * from "./RuleCustomEditOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e0a7d8",
  null
  
)

export default component.exports